import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL;

const config = (user) => ({
  headers: { Authorization: `Bearer ${user.token}` },
  params: { cache_bust: new Date().getTime() },
});

// Los dos dejan pasar el error de axios tal cual: quien llama necesita
// `error.response.status` y `error.response.data.detail` para explicar un 409
// (sin revisor, sin PDF) en pantalla.

export const previewReviewerNotice = async (user, groupId) => {
  const response = await axios.get(
    `${BASE_URL}/groups/${groupId}/reviewer-notice`,
    config(user)
  );
  return response.data;
};

export const sendReviewerNotice = async (user, groupId) => {
  const response = await axios.post(
    `${BASE_URL}/groups/${groupId}/reviewer-notice`,
    null,
    config(user)
  );
  return response.data;
};
